import "./new.scss";
import Sidebar from "../components/sidebar/Sidebar";
import { useEffect, useState } from "react";
import {
  doc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { auth, db, storage } from "../../../firebase";
import { useTranslation } from "react-i18next";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import { userInputs } from "../../../forms/userFormSource";
import Navbar1 from "../../main/Navbar1";
import Spinner from "../../Spinner";
import emailController from "../../../controllers/emailController";

let id = '';
const New = ({ inputs, title }) => {
  const { t } = useTranslation();
  const [file, setFile] = useState("");
  const [data, setData] = useState({});
  const [per, setPerc] = useState(null);
  const navigate = useNavigate()

  if(localStorage.getItem('id') != null){
    id = localStorage.getItem('id');
  }

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    
  }, []);
  
  const uploadFile = async () => {
    const name = new Date().getTime() + file.name;

    const storageRef = ref(storage, file.name);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setPerc(progress);
        switch (snapshot.state) {
          case "paused":
            break;
          case "running":
            break;
          default:
            break;
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setData((prev) => ({ ...prev, img: downloadURL }));
        });
      }
    );
  };

  const handleInput = (e) => {
    const id = e.target.id;
    const value = e.target.value;

    setData({ ...data, [id]: value });
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if(file){
      try {
        await uploadFile();
      } catch (error) {
        console.log(error);
      }
    }
    try {
      createUserWithEmailAndPassword(
        auth,
        data.email,
        data.password
      ).then( async(value) =>{
        data.id = value.user.uid;
        data.type = 'admin';
        data.createdBy = id;
        await setDoc(doc(db, "users", value.user.uid), {
          ...data,
          createdAt: serverTimestamp(),
        });
        await setDoc(doc(db, "admin", value.user.uid), {
          ...data,
          createdAt: serverTimestamp()
        });
        emailController.sendEmailToAdmin(data).then(ans =>{
          if(ans){
            window.alert('Utilisateur enregistrée avec succès !');
            navigate(-1);
          }
          else{
              setIsLoading(false);
              window.alert('Une erreur est survenue, veuillez essayer plus tard !');
          }
        });
      });
    } catch (err) {
      setIsLoading(false);
      window.alert('Une erreur est survenue, veuillez essayer !');
      console.log(err);
    }
  };

  const handleReturn = async (id) => {
    navigate(-1);
  }

  if (isLoading) {
    return <Spinner />
  }

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar1 />
        <input type="button" className="btn btn-primary m-3" value={t('return')} onClick={handleReturn}/>
        <div className="top">
          <h1>{t('add_new_administrator')}</h1>
        </div>
        <div className="bottom">
          <div className="left">
            {/* <img
              src={
                file
                  ? URL.createObjectURL(file)
                  : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
              }
              alt=""
            /> */}
          </div>
          <div className="right">
            <form onSubmit={handleAdd}>
              {/* <div className="formInput">
                <label htmlFor="file">
                  Image: <DriveFolderUploadOutlinedIcon className="icon" />
                </label>
                <input
                  type="file"
                  id="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  style={{ display: "none" }}
                />
              </div> */}

              {userInputs.map((input) => (
                <div className="formInput" key={input.id}>
                  <label>{input.label}</label>
                  <input
                    id={input.id}
                    type={input.type}
                    placeholder={input.placeholder}
                    onChange={handleInput}
                  />
                </div>
              ))}
              <button disabled={per !== null && per < 100} type="submit" className="btn btn-outline-primary">
                {t('save')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default New;
